import { Navigate } from 'react-router-dom'
import { useAuth } from '@/src/contexts/AuthContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  permissions?: string[]
  permissionsAll?: string[]
  roles?: string[]
  redirectTo?: string
}

export function ProtectedRoute({ 
  children, 
  permissions,
  permissionsAll,
  roles,
  redirectTo = '/auth/login'
}: ProtectedRouteProps) {
  const { user, loading, checkAccess } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary"></div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />
  }

  const hasAccess = checkAccess({
    permissions,
    permissionsAll,
    roles
  })

  console.log('🔒 ProtectedRoute check:', {
    requiredPermissions: permissions,
    requiredRoles: roles,
    userPermissions: user.permissions?.slice(0, 5),
    userRole: user.roleCode,
    hasAccess
  })

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />
  }

  return <>{children}</>
}
